import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { conferirInputFixa, listarConferenciasInputFixa } from '@/lib/inputFixaConferencia';

export function useConferenciasInputFixa(pedidoId: string | null | undefined, ativo: boolean) {
  return useQuery({
    queryKey: ['input-fixa-conferencias', pedidoId],
    enabled: !!pedidoId && ativo,
    staleTime: 15_000,
    queryFn: () => listarConferenciasInputFixa(pedidoId!),
  });
}

export function useConferirInputFixaAgora(pedidoId: string | null | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => conferirInputFixa(pedidoId!, 'importacao'),
    onSettled: () => qc.invalidateQueries({ queryKey: ['input-fixa-conferencias', pedidoId] }),
  });
}
